/**
 * formatApiErrorDetail — coerce a FastAPI error response (string OR
 * Pydantic 422 validation array) into a plain string so it can be
 * rendered safely in JSX / passed to toast.error.
 *
 * React crashes hard on `{detail}` when detail is `[{type, loc, msg, …}]`
 * (e.g., 422 from Pydantic) — every catch block in the app should funnel
 * its `err.response?.data?.detail` through this helper before setState.
 */
export function formatApiErrorDetail(err, fallback = 'Request failed') {
  const detail = err?.response?.data?.detail;
  if (Array.isArray(detail)) {
    return detail
      .map((d) => {
        if (typeof d === 'string') return d;
        if (d && typeof d === 'object') {
          // Pydantic v2 validation error shape
          const loc = Array.isArray(d.loc) ? d.loc.filter((x) => x !== 'body').join('.') : '';
          const msg = d.msg || d.message || JSON.stringify(d);
          return loc ? `${loc}: ${msg}` : msg;
        }
        return String(d);
      })
      .join('; ');
  }
  if (typeof detail === 'string') return detail;
  if (detail && typeof detail === 'object') return JSON.stringify(detail);
  return err?.message || fallback;
}
